import React, { useState, useEffect, useContext } from "react";
import Skeleton from "../../../lib/components/skeleton";
import RenderMachine from "../../../lib/components/renderMachine";
import baseHelper from "../../../lib/helper/baseHelper";
import NoDataFoundMessage from "../../../lib/components/noDataFoundMessage";
import BrandData from "../../../lib/components/context/builderData";
import HtmlHead from "../../../lib/components/htmlHead";
import VendorChat from "./customerChat";

export default function Brand(props) {
  const [data, setData] = useState({});
  const [hasData, setHasData] = useState();
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { vendorData } = useContext(BrandData);
  const { brandDetail, chatSetting = {} } = vendorData;
  const { isCustomer = true } = chatSetting || {};
  const brandIcon =
    (brandDetail && brandDetail.brand && brandDetail.brand.imageUrl) || "";
  const { shop, brandName } = props.match.params;

  const type = "brand";
  const filter = {
    type,
    shop,
    isPublished: true,
  };

  const dataStates = {
    data,
    setData,
    hasError,
    isLoading,
    setHasData,
    setHasError,
    setIsLoading,
  };

  useEffect(() => {
    baseHelper.getProviderTemplate(dataStates, filter, shop, brandName);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading && !hasError)
    return (
      <div className="w-100">
        <Skeleton builder={false} sidebar={false} />
      </div>
    );
  if (hasError)
    return (
      <div className="h-100vh d-flex justify-content-center align-items-center">
        An unexpected error has occurred.
      </div>
    );
  if (!hasData)
    return (
      <div className="d-flex justify-content-center align-items-center w-100 h-100vh">
        <NoDataFoundMessage brandName={brandName === "null" && shop || brandName} logo={brandIcon} />
      </div>
    );
  if (hasData)
    return (
      <>
        <HtmlHead title={brandName} favicon={brandIcon} />
        <RenderMachine
          builderClass="drag-n-drop " /* "drag-n-drop draggable" */
          data={data.data}
          type={type}
          match={props.match}
          history={props.history}
          builderPage={false}
        />
        {isCustomer && <VendorChat vendorData={vendorData} shop={shop} brandName={brandName} />}
      </>
    );
}
